var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("title", null, "83E6C290-FB62-4507-9157-F87AC1BE0781@1.5x");

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 0.464611111 7.66928 0.464611111 7.66928 14.5562778 0 14.5562778"
}));

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  id: "Recruiter-Web",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Profile---Recruiter",
  transform: "translate(-646.000000, -1435.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Thumbs-Down",
  transform: "translate(646.000000, 1435.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#D30028",
  cx: 25.5,
  cy: 25.5,
  r: 25.5
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(13.000000, 14.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.8902711,4.5429944 L22.7356116,4.5429944 C23.7548205,4.5429944 24.5814277,5.33641059 24.5814277,6.31477098 C24.5814277,7.29313136 23.7548205,8.08598881 22.7356116,8.08598881 L23.1530131,8.08598881 C24.1739783,8.08598881 25,8.879405 25,9.85776538 C25,10.8361258 24.1739783,11.629542 23.1547693,11.629542 L22.3070872,11.629542 C23.3268816,11.629542 24.1529033,12.4229581 24.1529033,13.4013185 C24.1529033,14.3791202 23.3268816,15.1725364 22.3070872,15.1725364 L16.6806557,15.1725364 C17.5377044,17.2337422 18.260693,19.7307682 17.2684132,22.7597184 C16.9628261,23.6928205 15.9272255,24.2113347 14.9548498,23.9179942 C13.9824741,23.6246538 13.5674143,22.6597032 13.7477224,21.6969877 C14.6287732,16.9862187 9,15.4429684 9,13.8203764 L9,2.7645129 C9,2.51531317 9.16508726,2.29293314 9.41096191,2.20912157 C10.4371959,1.86214168 13.1429878,1 14.7306355,1 L21.8902711,1 C22.9094801,1 23.7355018,1.79285745 23.7355018,2.77177657 C23.7355018,3.75013696 22.9094801,4.5429944 21.8902711,4.5429944",
  id: "Fill-1",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-5"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.56421333,2.3185 C6.56421333,2.77127778 6.21381333,3.1385 5.78128,3.1385 C5.34928,3.1385 4.99834667,2.77127778 4.99834667,2.3185 C4.99834667,1.86572222 5.34928,1.4985 5.78128,1.4985 C6.21381333,1.4985 6.56421333,1.86572222 6.56421333,2.3185 L6.56421333,2.3185 Z M7.66928,1.38905556 C7.66928,0.8785 7.27194667,0.464611111 6.78181333,0.464611111 L0.887413333,0.464611111 C0.39728,0.464611111 -5.33333333e-05,0.8785 -5.33333333e-05,1.38905556 L-5.33333333e-05,13.6318333 C-5.33333333e-05,14.1423889 0.39728,14.5562778 0.887413333,14.5562778 L6.78181333,14.5562778 C7.27194667,14.5562778 7.66928,14.1423889 7.66928,13.6318333 L7.66928,1.38905556 Z",
  id: "Fill-3",
  fill: "#FFFFFF",
  mask: "url(#mask-2)"
}))))));

var SvgSkipMatchButton = function SvgSkipMatchButton(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "51px",
    viewBox: "0 0 51 51",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSkipMatchButton, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/skip-match-button.b0df0afe.svg";
export { ForwardRef as ReactComponent };